<div class="notification" [ngClass]="type">
  <div class="notification-header">
    <div class="notification-icon-title">
      <hyperkit-icon
        [icon]="iconClass"
        size="large"
        [color]="type"
      ></hyperkit-icon>
      <hyperkit-typography class="title" variant="h6" color="primary">{{
        header
      }}</hyperkit-typography>
    </div>
    <button *ngIf="closeable" class="close-button" (click)="onClose()">
      <span>×</span>
    </button>
  </div>
  <div class="notification-body">
    <hyperkit-typography class="title" variant="body1" color="body">{{
      body
    }}</hyperkit-typography>
  </div>
  <div class="notification-actions" *ngIf="showActions">
    <button class="action-button primary">Primary</button>
    <button class="action-button secondary">Secondary</button>
  </div>
</div>
